import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  goBack() {
    history.back()
  }

  goToUrl(event) {
    if(event.ctrlKey || event.metaKey) {
      window.open(this.data.get('url'), '_blank');
    } else {
      Turbo.visit(this.data.get('url'))
    }
  }
}
